import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaVideo } from "react-icons/fa";
import { MdDelete, MdFileDownload, MdModeEdit, MdVideoLibrary } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";
import TableEmptyState from "../ReusableComponents/TableEmptyState";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import { saveAs } from 'file-saver';
import { API_URL, URL } from "../../variables";
import { DatePicker, TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { Form, FormControl as Input, InputGroup, Select, Spinner, FormCheck } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import DefaultButton from "../ReusableComponents/DefaultButton";
import { RiCloseFill } from "react-icons/ri";
import Attention from "../ReusableComponents/Attention";

var pesquisarTimeout = null;

const Candidatos = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_zip, setLoadingZip] = useState(false);

  const [loading_entrevistas, setLoadingentrevistas] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');
  const [message_zip, setMessageZip] = useState('');


  const [message_zip2, setMessageZip2] = useState('');
  const [loading_zip2, setLoadingZip2] = useState(false);


  const [entrevistas, setentrevistas] = useState([]);

  const [questoes, setquestoes] = useState([]);
  const [candidatoSelect, setCandidatoSelect] = useState({});
  const [loading_save, setLoadingSave] = useState(false);
  const [msgErro, setMsgErro] = useState('');


  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });
  const { entrevista, processo } = props;

  const [inicio, setInicio] = useState(moment(processo.inicio));
  const [fim, setFim] = useState(moment(processo.inicio));
  const [hora_inicio, setHoraInicio] = useState(moment(processo.inicio));
  const [hora_fim, setHoraFim] = useState(moment(processo.inicio).add('hour', 1));



  const [search, setSearch] = useState('');
  const [show_warning, setShowWarning] = useState(false);
  const [show_modal_edit, setShowModalEdit] = useState(false);

  const [entrevistas_id, setRedacaoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [entrevistaSelect, setProvaSelect] = useState(null);


  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();
  const timerRef = useRef(null);
  const timerRefZip = useRef(null);


  const GetCandidatos = async (page, search) => {

    let response = await Request.Get(`faculdade/get_candidatos_entrevista/${entrevista.id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {

      setentrevistas(response.candidatos);



      setPagination(response.pagination);
      setLoadingScreen(false);
      setLoadingentrevistas(false);


    }
  };


  const SaveDatetime = async () => {
    setLoadingSave(true);
    let response = await Request.Post(`faculdade/save_date_time`, JSON.stringify({
      entrevista_id: entrevista.id,
      inicio: inicio.format('YYYY-MM-DD') + ' ' + hora_inicio.format('HH:mm'),
      fim: fim.format('YYYY-MM-DD') + ' ' + hora_fim.format('HH:mm'),
      student_id: candidatoSelect.id
    }), {
      'Content-type': 'application/json'
    });
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    } else
    if (response.errors != null || response.error != null) {
      let errors = Object.values(response.errors);
      let erro = '';
      for (let i = 0; i < errors.length; i++) {
        if (i != errors.length - 1)
        erro += errors[i] + '\n';else

        erro += errors[i];
      }
      console.log(erro);
      window.scrollTo(500, 0);
      setLoadingSave(false);
      setMsgErro(erro);
    } else
    {
      setLoadingSave(false);
      setShowModalEdit(false);
      setLoadingentrevistas(true);
      GetCandidatos(pagination.current_page, search_oficial);

    }

  };


  const GetCandidatosPdfZip = async () => {

    let response = await Request.Get(`faculdade/download_diagramacoes/${entrevista.id}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    // else if(response['status']==undefined){
    //     setLoadingZip(false);

    //     saveAs(response,'redacoes_processo_'+processo_name+'.zip');
    // }
    else {
      if (response['status'] == true) {
        document.getElementById('download_link').href = response['path'];
        document.getElementById('download_link').click();
        setLoadingZip(false);
        setMessageZip('');

        return;
      } else
      if (response['status'] != 'Error') {
        setMessageZip(response['message']);
      }
      timerRef.current = setTimeout(() => {
        GetCandidatosPdfZip();
      }, 20000);

    }


  };




  const GetRelatorios = async () => {

    let response = await Request.Get(`faculdade/get_respostas_entrevista/${entrevista.id}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    // else if(response['status']==undefined){
    //     setLoadingZip(false);

    //     saveAs(response,'entrevistas_processo_'+processo_name+'.zip');
    // }
    else {
      // setLoadingZip(false);
      // setMessageZip('');
      let blobo = new Blob([response['csv']]);

      if (response['status'] == true) {
        saveAs(blobo, 'resultados_' + entrevista.name + '.csv');
      }

      setLoadingZip(false);


    }


  };

  const DeleteRedacao = async (entrevistas_id) => {

    let response = await Request.Delete(`faculdade/desvincular_entrevista/${entrevistas_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    GetCandidatos(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    GetCandidatos(1, search_oficial);

    return () => {
      clearTimeout(timerRef.current);
      clearTimeout(timerRefZip.current);

    };
  }, []);

  const history = useHistory();
  return (
    <div className="row">

            <div className="col-12">

                <a id="download_link" target="_blank"></a>

                {/* <hr /> */}
                {loading_screen == false && <div className="module-card-container">

                    <div className="module-breadcrumb">

                        <button
              className="breadcrumb-back"
              onClick={() =>
              props.setState({
                activeTab: -1
              })
              }>{t("dashboard")}


            </button>

                        <span>/</span>

                        <strong>{`
                            ${t("candidates")}
                        `}</strong>

                    </div>

                    <div className="module-title-row">

                        <div>

                            <h3 style={{ fontWeight: 'bold' }}>{t("ui_candidatos_da_entrevista_a9e44072")}

              </h3>

                            <p>{`
                                ${t("legacy_gerencie_as_avaliacoes_orais_dos_candidatos")}
                            `}</p>

                        </div>

                        <button
              className="btn-dashboard-modern"
              onClick={() =>
              props.setState({
                activeTab: -1
              })
              }>{`
                            ${t("legacy_dashboard")}
                        `}
            </button>

                    </div>

                    <a
            id="download_link"
            target="_blank"
            rel="noreferrer" />


                    <div className="module-toolbar">

                        <Search
              placeholder={t("legacy_pesquisar_por_nome_cpf_ou_inscricao")}
              ValueChange={(value) => {

                clearTimeout(pesquisarTimeout);

                setSearchOficial(value);

                pesquisarTimeout = setTimeout(() => {

                  let page = { ...pagination };

                  page.current_page = 1;

                  setPagination(page);

                  setLoadingentrevistas(true);

                  GetCandidatos(1, value);

                }, 500);

              }} />


                        <div className="module-actions">

                            {!loading_zip &&

              <button
                className="btn-module-primary"
                onClick={() => {

                  setLoadingZip(true);

                  setMessageZip(
                    'Criando relatório para download'
                  );

                  GetRelatorios();

                }}>


                                    <MdFileDownload />{`

                                    ${t("legacy_baixar_planilha")}

                                `}</button>

              }

                            {loading_zip &&

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10
                }}>


                                    <CircularProgress size={18} />

                                    <span
                  style={{
                    fontSize: 13,
                    color: '#b45309'
                  }}>

                                        {message_zip}
                                    </span>

                                </div>

              }

                        </div>

                    </div>

                    <div className="table-modern-card">

                        <table
              id="tech-companies-1"
              className="table table-striped">


                            <thead>

                                <tr>

                                    <th>{t("label_name")}</th>

                                    <th>{t("legacy_cpf")}</th>

                                    <th>{t("legacy_inscricao")}</th>

                                    <th>{t("ui_avaliacao_b83b6158")}</th>

                                    <th>{t("label_module_status")}</th>

                                    <th>{t("label_actions")}</th>

                                </tr>

                            </thead>

                            <tbody>

                                {!loading_entrevistas &&
                entrevistas.map((item, id) =>

                <tr key={id}>

                                            <td>

                                                <strong>
                                                    {item.name}
                                                </strong>

                                            </td>

                                            <td>
                                                {item.cpf}
                                            </td>

                                            <td>
                                                {item.numero_inscricao}
                                            </td>

                                            <td>

                                                {item.exams_oral?.datetime_initial ?

                    <div
                      style={{
                        fontSize: 13
                      }}>


                                                        <div>

                                                            <strong>{t("ui_inicio_3ea3dd6c")}</strong>{" "}
                                                            {moment(
                          item.exams_oral.datetime_initial
                        ).format(
                          "DD/MM/YYYY HH:mm"
                        )}

                                                        </div>

                                                        <div>

                                                            <strong>Fim:</strong>{" "}
                                                            {moment(
                          item.exams_oral.datetime_end
                        ).format(
                          "DD/MM/YYYY HH:mm"
                        )}

                                                        </div>

                                                    </div> :



                    "-"

                    }

                                            </td>

                                            <td>

                                                <span
                      className={`trust-badge ${item.exams_oral?.finish ?
                      "trust-low" :
                      "trust-high"}`
                      }>

                                                    {item.exams_oral?.finish ?
                      "Concluída" :
                      "Pendente"}
                                                </span>

                                            </td>

                                            <td>

                                                <div className="actions-group">

                                                    <button
                        className="action-btn warning"
                        title={`Ver avaliação de ${item.name}`}
                        onClick={() => {

                          setCandidatoSelect(item);

                          setMsgErro('');

                          setShowModal(true);

                        }}>


                                                        <BsFillEyeFill />

                                                    </button>

                                                    <button
                        className="action-btn info"
                        title={t("legacy_editar_horario")}
                        onClick={() => {

                          setCandidatoSelect(item);

                          if (
                          item.exams_oral?.
                          datetime_initial)
                          {

                            setInicio(
                              moment(
                                item.exams_oral.datetime_initial
                              )
                            );

                            setHoraInicio(
                              moment(
                                item.exams_oral.datetime_initial
                              )
                            );

                            setFim(
                              moment(
                                item.exams_oral.datetime_end
                              )
                            );

                            setHoraFim(
                              moment(
                                item.exams_oral.datetime_end
                              )
                            );

                          }

                          setMsgErro('');

                          setShowModalEdit(true);

                        }}>


                                                        <MdModeEdit />

                                                    </button>

                                                </div>

                                            </td>

                                        </tr>

                )}

                            </tbody>

                        </table>

                        {loading_entrevistas &&

            <div className="row m-0">

                                <div className="col-12 d-flex justify-content-center align-items-center">

                                    <CircularProgress />

                                </div>

                            </div>

            }

                    </div>

                    {!loading_entrevistas &&
          entrevistas.length === 0 &&

          <TableEmptyState title={t("empty_no_candidate_found")} description={t("ui_nenhum_candidato_foi_vinculado_a_entrevista_1a26c285")} icon="🎤" />

          }

                    <Pagination
            className={
            pagination.last_page === 1 ?
            "hide" :
            ""
            }
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px"
            }}
            count={pagination.last_page}
            value={pagination.current_page}
            onChange={(_, value) => {

              setLoadingentrevistas(true);

              let page = { ...pagination };

              page.current_page = value;

              setPagination(page);

              GetCandidatos(
                value,
                search_oficial
              );

            }} />


                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
              </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
          warning
          title={t("legacy_atencao")}
          onConfirm={() => {
            setShowWarning(false);
            setLoadingentrevistas(true);
            DeleteRedacao(entrevistas_id);
            // this.delete_banner(this.state.banner_to_delete);
          }}
          onCancel={() => {
            setShowWarning(false);
          }}
          show={show_warning}
          confirmBtnText={t("ui_sim_desejo_desvincular_91364237")}
          cancelBtnText={t("legacy_cancelar")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          showCancel={true}>{t("ui_ao_desvincular_este_entrevista_ele_nao_tera_mais_a_3e116a66")}


        </SweetAlert>

                <Modal
          show={show_modal_edit == true}
          dialogClassName="modal_width"
          onHide={() => {
            setShowModalEdit(false);
          }}>

                    <Modal.Header closeButton closeLabel=''><Modal.Title>{`${t("legacy_candidato")} `}{candidatoSelect?.name}<br />
                    </Modal.Title></Modal.Header>
                    <Modal.Body>
                        {msgErro != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
                            <div className="badge badge-danger error-message-badge error-message-badge-dismissible w-100" role="alert">
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setMsgErro('')}></button>


                                <p style={{ marginBottom: 0, whiteSpace: 'pre' }}>{msgErro}</p>

                            </div>
                            <br />

                        </div>}

                        <MuiPickersUtilsProvider utils={MomentUtils}>

                            <InputGroup>

                                <div className="flex fdcolumn flex1 margin-bottom me-3">
                                    <Form.Label>{`${t("legacy_data_de_inicio")} `}<Attention /></Form.Label>
                                    <DatePicker
                    autoOk
                    margin="normal"
                    style={{ width: '100%' }}
                    invalidDateMessage={t("ui_data_invalida_76fc5825")}
                    ampm={false}
                    minDate={moment(processo.inicio)}
                    maxData={moment(processo.fim)}
                    id="time-picker"
                    cancelLabel={t("legacy_cancelar")}
                    clearLabel={this.context.t("action_clear")}
                    format="DD/MM/YYYY"
                    value={inicio}
                    onChange={(date) => setInicio(date)} />


                                </div>
                                <div className="flex fdcolumn flex1 margin-bottom">
                                    <Form.Label>{t("ui_horario_de_inicio_701ca30c")}<Attention /></Form.Label>
                                    <TimePicker
                    autoOk
                    margin="normal"
                    style={{ width: '100%' }}
                    invalidDateMessage={t("ui_horario_invalido_6d7a8390")}
                    ampm={false}
                    id="time-picker"
                    cancelLabel={t("legacy_cancelar")}
                    clearLabel={this.context.t("action_clear")}
                    label=""
                    value={hora_inicio}
                    onChange={(date) => {setHoraInicio(date);}} />


                                </div>
                            </InputGroup>

                            <InputGroup>

                                <div className="flex fdcolumn flex1 margin-bottom me-3">
                                    <Form.Label>{`${t("legacy_data_de_encerramento")} `}<Attention /></Form.Label>
                                    <DatePicker
                    autoOk
                    margin="normal"
                    style={{ width: '100%' }}
                    invalidDateMessage={t("ui_data_invalida_76fc5825")}
                    ampm={false}
                    minDate={moment(processo.inicio)}
                    maxData={moment(processo.fim)}
                    id="time-picker"
                    cancelLabel={t("legacy_cancelar")}
                    clearLabel={this.context.t("action_clear")}
                    format="DD/MM/YYYY"
                    value={fim}
                    onChange={(date) => {setFim(date);}} />


                                </div>
                                <div className="flex fdcolumn flex1 margin-bottom">
                                    <Form.Label>{`${t("label_end_time")} `}<Attention /></Form.Label>
                                    <TimePicker
                    autoOk
                    margin="normal"
                    style={{ width: '100%' }}
                    invalidDateMessage={t("ui_horario_invalido_6d7a8390")}
                    ampm={false}
                    id="time-picker"
                    cancelLabel={t("legacy_cancelar")}
                    clearLabel={this.context.t("action_clear")}
                    label=""
                    value={hora_fim}
                    onChange={(date) => {setHoraFim(date);}} />


                                </div>
                            </InputGroup>



                        </MuiPickersUtilsProvider>




                        {loading_save == false && <div className="w100 inline-flex jcsb margin-top-1">
                            {/* <Link to={`/accounts/list`}>
                <Button variant="secondary"><RiArrowGoBackLine/> Voltar</Button>
                </Link> */}
                            <DefaultButton
                bg="secondary"
                text={t("action_close")}
                icon={<RiCloseFill />}
                onClick={() => {
                  setShowModalEdit(false);
                }} />

                            {/* <Button variant="success" type="submit" disabled={this.loading}>
                {this.state.loading ? <Spinner /> : ""}
                Registrar usuário
                </Button> */}
                            <DefaultButton
                type="button"

                onClick={() => {
                  SaveDatetime();
                }}
                bg={"confirm"}
                text={t("action_save")} />

                        </div>}
                        {loading_save == true && <div className="w100 inline-flex justify-content-end margin-top-1">
                            <CircularProgress />
                        </div>}


                    </Modal.Body>
                </Modal>






                <Modal
          show={showModal == true}
          dialogClassName="modal_width"
          onHide={() => {
            setShowModal(false);
          }}>

                    <Modal.Header closeButton closeLabel=''><Modal.Title>{`${t("legacy_candidato")} `}{candidatoSelect?.name}<br />
                    </Modal.Title></Modal.Header>
                    <Modal.Body>
                        <p style={{}}><b style={{ color: 'black', fontSize: 18 }}>{t("ui_criterios_5fb45232")}</b> </p>

                        <div className="table-modern-card">
                            <div className="table-modern-scroll mb-0">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{t("legacy_avaliador")}</th>
                                            <th>{t("legacy_codigo_do_criterio")}</th>
                                            <th>{t("legacy_texto_do_criterio")}</th>
                                            <th>Range</th>
                                            <th>{t("legacy_nota")}</th>
                                        </tr>

                                    </thead>
                                    <tbody>

                                        {candidatoSelect?.exams_oral?.grades?.map((item, id) =>
                    <tr key={id}>
                                                <td>
                                                    {item.avaliador.name}
                                                </td>
                                                <td>
                                                    {item.criterio.code}

                                                </td>
                                                <td>
                                                    {item.criterio.text}

                                                </td>
                                                <td>
                                                    {item.criterio.min_score} - {item.criterio.max_score}
                                                </td>
                                                <td>
                                                    {item.grade}

                                                </td>
                                            </tr>
                    )}

                                        {candidatoSelect?.exams_oral?.grades?.length == 0 && <tr>
                                            <td colSpan="5">{t("legacy_nenhuma_nota_registrada")}</td>
                                        </tr>}



                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <p style={{ color: 'black', marginBottom: 10 }}><b>Nota final:</b> {candidatoSelect?.exams_oral?.grades?.map((item) => parseFloat(item.grade))?.reduce((accumulator, currentValue) => {
                return parseFloat(accumulator) + parseFloat(currentValue);
              }, 0)}</p>




                        {loading_save == false && <div className="w100 inline-flex jcsb margin-top-1">
                            {/* <Link to={`/accounts/list`}>
                <Button variant="secondary"><RiArrowGoBackLine/> Voltar</Button>
                </Link> */}
                            <DefaultButton
                bg="secondary"
                text={t("action_close")}
                icon={<RiCloseFill />}
                onClick={() => {
                  setShowModal(false);
                }} />

                            {/* <Button variant="success" type="submit" disabled={this.loading}>
                {this.state.loading ? <Spinner /> : ""}
                Registrar usuário
                </Button> */}

                        </div>}
                        {loading_save == true && <div className="w100 inline-flex justify-content-end margin-top-1">
                            <CircularProgress />
                        </div>}


                    </Modal.Body>
                </Modal>


            </div>

        </div>);

};

export default Candidatos;
